// extracted by mini-css-extract-plugin
export default {"msg-container":"Message_msg-container__Ae7pM","msg-box":"Message_msg-box__IE9JM","success-message":"Message_success-message__jvlm2"};